module.exports = __webpack_public_path__ + "static/img/arrow-left-color.192b6e1c.svg";